import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, OnInit, Output } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { MarkdownModule } from 'ngx-markdown';
import { ToastrModule } from 'ngx-toastr';

import { cn } from '@valk-nx/core/lib/core';

import { AlertType } from './contracts/alert.types';

@Component({
	animations: [
		trigger('alertAnimationTrigger', [
			state(
				'visible',
				style({
					opacity: 1,
				}),
			),
			state(
				'hidden',
				style({
					opacity: 0,
				}),
			),
			transition('* <=> *', animate('50ms ease-in-out')),
		]),
	],
	selector: 'vp-alert',
	imports: [AngularSvgIconModule, CommonModule, MarkdownModule, ToastrModule],
	templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit {
	title = input('');
	content = input('');
	subContent = input('');
	closeable = input(false);
	emphasized = input(false);
	isToastr = input(false);
	hasElevation = input(false);
	type = input<AlertType>('dialog--info');
	size = input<'base' | 'small'>('base');
	className = input('');

	@Output() closeEmitter = new EventEmitter();

	animationState = 'visible';
	hidden = false;

	cn = cn;

	ngOnInit(): void {
		if (this.isToastr()) {
			this.animationState = 'visible';
		}
	}

	remove() {
		if (!this.isToastr()) {
			this.animationState = 'hidden';
		} else {
			this.closeEmitter.emit();
		}
	}

	onAlertVisibilityChange() {
		if (this.animationState === 'hidden' && !this.isToastr()) {
			this.hidden = true;
		}
	}
}
